import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import './pricing.css';

import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  withRouter,

} from 'react-router-dom'

import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';


const styles = theme => ({
  listItem: {
    padding: `${theme.spacing.unit}px 0`,
  },
  total: {
    fontWeight: '700',
  },
  title: {
    marginTop: theme.spacing.unit * 2,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paper: {
    // marginTop: theme.spacing.unit * 3,
    textAlign: 'center',
    width: '100%',
    height: '100%',
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit,
    paddingBottom: '0px',
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      // marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 2,
      paddingBottom: '0px',
    },
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  button: {
    // margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    width: '100%',
    // lineHeight: 1.5,
    backgroundColor: 'rgb(37,106,167)',
    borderColor: 'rgb(37,106,167)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },

  buttonBack: {

    textTransform: 'none',
    fontSize: 16,
    padding: '3px 6px',
    color: '#203b60',
    width: '100%',
    backgroundColor: '#f2f2f2',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),

  },
  companyData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: '100%',
  },
  commonMargin: {
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 8
  }
});

class LandingSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.goCloudPrices = this.goCloudPrices.bind(this)
    this.goInCompanyForm = this.goInCompanyForm.bind(this)

  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  goCloudPrices() {

    this.props.history.push({
      pathname: '/selection',
    })

  }

  goInCompanyForm(){
    console.log("in Company Form")
    this.props.history.push({
      pathname: '/contact_form',
    })
  }


  render() {
    const { classes } = this.props;
    return (

      <React.Fragment>
        <CssBaseline />


        <main style={{ marginTop: '100px', paddingTop: "10px" }} className={classes.layout}>
          <CSSTransition
            //  key={item.id}
            in
            appear
            timeout={600}
            classNames="fade500"
          >

            <h3 style={{ textAlign: 'center', marginBottom: "30px" }}>¿Que tipo de Implementación desea?</h3>
          </CSSTransition>



          <Grid container spacing={40} justify="center" style={{ marginBottom: "20px" }}>

            <Grid item xs={12} sm={4}>
              <Paper className={classes.paper}>
                {/* <div className="pricing-title"> Resumen de Servicios</div> */}
                <div className="table-responsive">
                  <img className="img-fuid pb-3" width="216"
                    height="226" src="./img/implementacion-sitio.png"></img>
                  <div className="pricing-title">Kalenis In Company</div>
                  <table style={{ fontSize: "14px" }} className='price-grid-table'>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content">Implemente Kalenis dentro de su organización</td>
                        {/* <td style={{ textAlign: 'right' }}>$   USD</td> */}

                      </tr>
                      <tr>
                        {/* <td className="td-support-content">{data.selected_pack_data.id === 99 ? "" : "Implementación:"} {data.selected_pack_data.name}  {data.selected_pack_data.new !== 0 ? <sup>(2)</sup> : ""}</td> */}
                        {/* <td style={{ textAlign: 'right' }}>$ {data.selected_pack_data.new} USD</td> */}

                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content">Forme su equipo de desarrollo interno</td>

                      </tr>
                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content"> Sin costos de licencia</td>

                      </tr>
                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content"> Instale y utilice su propia infraestructura</td>

                      </tr>
                      <tr><td style={{ border: '0px' }}></td></tr>
                      <tr>
                        <td style={{ border: '0px' }}>
                          <Button variant="contained" onClick={this.goInCompanyForm} className={classes.buttonBack}>
                            Consultar
                          </Button>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Paper>
            </Grid>


            <Grid item xs={12} sm={4}>

              <Paper className={classes.paper}>
                {/* <div className="pricing-title"> Resumen de Servicios</div> */}
                <div className="table-responsive">
                  <img width="277"
                    height="226" className="img-fuid pb-3" src="/img/implementacion-cloud.png"></img>
                  <div className="pricing-title">Kalenis Cloud</div>
                  <table style={{ fontSize: "14px", border: '0px' }} className='price-grid-table'>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content"> Obtenga la solución para su laboratorio en minutos </td>
                        {/* <td style={{ textAlign: 'right' }}>$   USD</td> */}

                      </tr>
                      <tr>
                        {/* <td className="td-support-content">{data.selected_pack_data.id === 99 ? "" : "Implementación:"} {data.selected_pack_data.name}  {data.selected_pack_data.new !== 0 ? <sup>(2)</sup> : ""}</td> */}
                        {/* <td style={{ textAlign: 'right' }}>$ {data.selected_pack_data.new} USD</td> */}

                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content">Sin costos de Infraestructura</td>
                        {/* <td style={{ textAlign: 'right' }}></td> */}

                      </tr>
                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content"> Disponible 24x7</td>
                        {/* <td style={{ textAlign: 'right' }}></td> */}

                      </tr>
                      <tr>
                        <td style={{ textAlign: 'center' }} className="td-support-content"> Estabilidad, seguridad y escalabilidad</td>
                        {/* <td style={{ textAlign: 'right' }}></td> */}

                      </tr>

                      <tr><td style={{ border: '0px' }}></td></tr>

                      <tr style={{ border: '0px' }}>
                        <td style={{ border: '0px' }}>
                          <Button variant="contained" className={classes.button}>
                            Probar Ahora<sup> (1)</sup>
                          </Button>

                        </td>
                      </tr>

                      <tr>
                        <td style={{ border: '0px' }}>
                          <Button variant="contained" onClick={this.goCloudPrices} className={classes.buttonBack}>
                            Ver Tarifas
                          </Button>

                        </td>
                      </tr>
                    </tbody>
                    <small ><sup>(1)</sup>:Prueba Gratuita por 30 días</small>
                  </table>
                </div>
              </Paper>
            </Grid>


            {/* <Grid item xs={12} sm={4}>
              <Paper className={classes.paper}>



                <React.Fragment>
                  <div className="pricing-title"> Medio de Pago</div>
                  <div style={{ marginTop: '10px' }}>

                    <div>Transferencia Bancaria</div>
                    <div className="td-support-content">Al concluir el proceso, recibirá por correo electrónico la información para realizar la transferencia. El servicio será habilitado 24hs luego de la acreditación</div>
                  </div>
                </React.Fragment>


              </Paper>
            </Grid> */}


          </Grid>



          {/* <div className={classes.buttons}>

            <Button onClick={this.confirmTransaction} variant="contained" className={classes.button}>
              Confirmar
        <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
            </Button>

          </div> */}

        </main>

      </React.Fragment>


    );
  }
}


LandingSelection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(LandingSelection));
